import { z } from 'zod';

/**
 * Notification types
 */
export enum NotificationType {
  BADGE_UNLOCKED = 'badge_unlocked',
  LEVEL_UP = 'level_up',
  PLAN_SHARED = 'plan_shared',
  COLLABORATOR_ADDED = 'collaborator_added',
  COMMENT_ADDED = 'comment_added',
  ACHIEVEMENT_EARNED = 'achievement_earned',
}

/**
 * Notification schema
 */
export const NotificationSchema = z.object({
  id: z.string(),
  userId: z.string(),
  type: z.nativeEnum(NotificationType),
  title: z.string(),
  message: z.string(),
  data: z.record(z.unknown()).optional(),
  read: z.boolean().default(false),
  createdAt: z.number(),
});

export type Notification = z.infer<typeof NotificationSchema>;

/**
 * Request schemas
 */
export const GetNotificationsQuerySchema = z.object({
  limit: z.coerce.number().int().min(1).max(100).default(20),
  offset: z.coerce.number().int().min(0).default(0),
  unreadOnly: z.coerce.boolean().optional(),
});

export const MarkReadBodySchema = z.object({
  notificationIds: z.array(z.string()).min(1),
});

export const MarkAllReadQuerySchema = z.object({
  before: z.coerce.number().int().optional(),
});

/**
 * Response schemas
 */
export const NotificationsResponseSchema = z.object({
  notifications: z.array(NotificationSchema),
  total: z.number().int(),
  unreadCount: z.number().int(),
});

export type NotificationsResponse = z.infer<typeof NotificationsResponseSchema>;
